<template>

    <div class="content-wrap page-kultur-genuss">

        <header class="hero--sm">
            <h1 class="hero-heading">
                <small>Kultur &amp; Genuss</small>
                in Kulmbach!
            </h1>
        </header>

        <section class="section--light">

            <div class="container">
                <div class="row">

                    <div class="col sm-6">

                        <h2>Eine runde Sache für „Bierologen“!</h2>

                        <ul>
                            <li>Ankunft am Bahnhof Kulmbach</li>
                            <li>Spaziergang zum Kulmbacher Mönchshof (Dauer 15 Min.)</li>
                            <li>Besuch des Bayerischen Brauereimuseums (Dauer 90 Min.)</li>
                            <li>Einkehr bei Zissel mit Bierprobe, Zapferprüfung und Biermenü (Open end)</li>
                            <li>Der Zissel-Wirt führt Sie humorvoll durch die Bierprobe.
                                Sie erfahren einiges über Bier und seine Herstellung.</li>
                        </ul>

                        <div class="infobox">

                            <h3>Sie trinken:</h3>
                            <p>
                                Das stärkste Bier der Welt sowie Zissel Hell, Zissel Dunkel,
                                Zissel Rauch und unsere neuen Mixgetränke. Das Bier-Probier-Glas dürfen Sie mitnehmen.
                                Dazu empfehlen wir unser Original Kulmbacher Bierfleisch.
                            </p>

                        </div>

                    </div>

                    <div class="col sm-6">
                        <img src="assets/img/kultur-genuss-content.jpg" alt="Brauereiführung">
                    </div>

                </div>
            </div>

        </section>


        <app-footer></app-footer>

    </div>


</template>

<script>
import setParallax from '../lib/setParallax'
import appFooter from './partials/footer.vue'

export default {
    components: { appFooter },

    mounted() {

        this.$nextTick(() => {

            setParallax({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            })

        })

    },
}

</script>



// WEBPACK FOOTER //
// kultur-genuss.vue?2ff79e14